/**
 * Configuração criptográfica e chave pública oficial do Passaporte ZapOrca Pro.
 * Utiliza o algoritmo padrão ECDSA P-256 (FIPS 186-4) com digest SHA-256
 * suportado nativamente por todos os navegadores modernos via Web Crypto API (crypto.subtle).
 *
 * Chave pública em formato SPKI (SubjectPublicKeyInfo) codificada em Base64.
 * Apenas assinaturas geradas com a chave privada correspondente do mantenedor (offline)
 * são consideradas autênticas. Zero requisições de rede.
 */

export const ZAPORCA_PRO_PUBLIC_KEY_SPKI_B64 =
  'MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEexgeQGiV/jROuPAy/yheVUqjPXctOHtMG9mKMGIMwZILgMjBn5d2mUwom5iPsi/ECRcbfof/yA4lfx8nUSMzUg==';

export const ZAPORCA_PRO_ALGO = {
  name: 'ECDSA',
  namedCurve: 'P-256',
} as const;

export const ZAPORCA_PRO_HASH = {
  name: 'SHA-256',
} as const;
